import React, { useState } from 'react';
import AllTools from '../data/tools/allTools';
import Header from '../components/LoadPages/AcademicCollaborationCard';

const PRIMARY_BLUE = '#0B5ED7';
const PRIMARY_BLUE_HOVER = '#0A58CA';

/* Icono genérico (se muestra si el link no trae imagen) */
const IconBadge = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">
    <defs>
      <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor={PRIMARY_BLUE} />
        <stop offset="1" stopColor="#1449A6" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="64" height="64" fill="url(#g)" />
    <circle cx="32" cy="32" r="18" fill="#fff" opacity="0.95" />
    <path d="M26 33.5l4.5 4.5L38 30" fill="none" stroke={PRIMARY_BLUE} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Card = ({ link }) => (
  <div style={styles.card}>
    <div style={styles.media}>
      {link.image ? (
        <img src={link.image} alt={link.name} style={styles.mediaImg} />
      ) : (
        <IconBadge />
      )}
    </div>

    <h3 style={styles.cardTitle}>{link.name}</h3>
    <p style={styles.cardDescription}>{link.description}</p>

    <a href={link.review_url} target="_blank" rel="noreferrer" style={styles.button}>
      Ver sitio
    </a>
  </div>
);

const Home = () => {
  const [selectedCategory] = useState(AllTools[0]);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredLinks = selectedCategory?.links?.filter((link) => {
    const q = searchTerm.toLowerCase();
    return link.name.toLowerCase().includes(q) || link.description.toLowerCase().includes(q);
  });

  return (
    <div className="serif-root" style={styles.page}>
      {/* Tipografía serif aplicada a todo */}
      <style>{`
        .serif-root, .serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: .01em;
        }
      `}</style>

      <Header title="Sitios Legítimos de Criptomonedas" subtitle="" />

      <input
        type="text"
        placeholder="Buscar exchange, sitio o utilidad…"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={styles.input}
        aria-label="Buscar sitios"
      />

      {filteredLinks?.length ? (
        <div style={styles.grid}>
          {filteredLinks.map((link, idx) => (
            <Card key={idx} link={link} />
          ))}
        </div>
      ) : (
        <p style={styles.empty}>No se encontraron resultados.</p>
      )}
    </div>
  );
};

const styles = {
  page: {
    padding: '5vw',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '1px solid #d8dde6',
    outline: 'none',
    marginBottom: '30px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px',
  },
  card: {
    backgroundColor: '#fff',
    border: '1px solid #e6ebf2',
    padding: '18px',
    display: 'flex',
    flexDirection: 'column',
    transition: 'border-color .15s ease',
  },
  media: {
    width: '100%',
    height: '160px',
    background: '#f5f7fb',
    display: 'grid',
    placeItems: 'center',
    marginBottom: '12px',
  },
  mediaImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: 700,
    margin: '6px 0 6px',
    color: '#111827',
  },
  cardDescription: {
    fontSize: '15px',
    color: '#4b5563',
    lineHeight: 1.45,
    flex: 1,
  },
  button: {
    marginTop: '16px',
    padding: '10px 16px',
    backgroundColor: PRIMARY_BLUE,
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 700,
    border: `1px solid ${PRIMARY_BLUE}`,
    borderRadius: 0, // sin bordes redondeados
    display: 'inline-block',
  },
  empty: {
    textAlign: 'center',
    marginTop: '40px',
    color: '#6b7280',
  },
};

export default Home;
